module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-4-668ebe7abd7855162c5c75b3d45707ae.jpg";